module.exports = __webpack_public_path__ + "img/icon-table-edit.9479f8fa.svg";